<script>
  import { onMount } from "svelte";
  import {
    business,
    user,
    showPopup,
    loading,
    isAdmin,
    orders,
    pageClicked,
    categoryFilters,
    ordersFilteredByCategory,
    closedOrders,
    openOrders,
    fcmToken,
    toastMsg,
  } from "../stores.js";
  import { flip } from "svelte/animate";
  import { fade } from "svelte/transition";
  import { querystring, location, push, pop } from "svelte-spa-router";

  import * as OrderDAL from "../dal/order-dal";
  import * as BusinessDAL from "../dal/business-dal";
  import * as UserDAL from "../dal/user-dal";
  import * as NotificationsBL from "../bl/notifications-bl";

  import { startAudioLoop } from "../audio-service.js";

  import AdminOrder from "./AdminOrder.svelte";
  import ClosedOrderItem from "./ClosedOrderItem.svelte";
  import EditStock from "./EditStock.svelte";
  import EditHours from "./EditHours.svelte";
  import EditDeliveries from "./EditDeliveries.svelte";
  import FaClock from "svelte-icons/fa/FaClock.svelte";
  import FaChartBar from "svelte-icons/fa/FaChartBar.svelte";
  import FaCopy from "svelte-icons/fa/FaCopy.svelte";
  import EditIcon from "./icons/EditIcon.svelte";
  import VespaIcon from "./icons/VespaIcon.svelte";

  import {
    menuItemCategories,
    formatHours,
    copyToClipboard,
  } from "../utils.js";

  let state = "Loading";
  let showCancel = false;
  let showEditStock = false;
  let showEditHours = false;
  let showEditDeliveries = false;
  let orderToCancel;
  let cancelReason;
  let isOpen;
  let openFrom;
  let openTo;
  let openToday;

  export let params = {};

  business.subscribe((b) => {
    console.log($closedOrders);
    if (!b) {
      state = "Not Found";
    } else {
      if (!$isAdmin && $isAdmin != "loading") {
        if ($location.includes("admin")) {
          push("/b/" + params.code);
        }
      }
    }
  });

  isAdmin.subscribe((ia) => {
    //if user logged out in the admin page we send him back to the menu
    if ($business && ia != "loading" && !ia) {
      push("/b/" + $business.code);
    }
  });

  onMount(async () => {
    if (!$pageClicked || !$user || !isAdmin) {
      push("/b/" + params.code);
      return;
    }
    if (!$business || $business.code != params.code) {
      state = "Loading";
      await getBusiness(params.code);
    }
  });

  querystring.subscribe((qs) => {
    showCancel = qs.search("showCancel=true") != -1;
    showEditStock = qs.search("editStock=true") != -1;
    showEditHours = qs.search("editHours=true") != -1;
    showEditDeliveries = qs.search("editDeliveries=true") != -1;
  });

  let getNotifications = false;

  $: {
    getNotifications =
      $user && $fcmToken && $business && $business.notifications[$fcmToken];
  }

  $: {
    if ($business?.schedule) {
      let date = new Date();
      let currentHour = date.getHours();
      let currentDay = date.getDay();

      openFrom = $business.schedule[currentDay].from;
      openTo = $business.schedule[currentDay].to;
      openToday = $business.schedule[currentDay].open;

      if (openToday) {
        if (openFrom < openTo) {
          isOpen = currentHour >= openFrom && currentHour < openTo;
        } else {
          isOpen = currentHour >= openFrom || currentHour < openTo;
        }

        isOpen = isOpen && $business.open;
      }
    }
  }

</script>

<main>
  {#if !$business}
    <h1>{state}</h1>
  {:else}
    {#if showEditStock}
      <EditStock />
    {/if}
    {#if showEditHours}
      <EditHours />
    {/if}
    {#if showEditDeliveries}
      <EditDeliveries />
    {/if}

    {#if showCancel}
      <div class="cancelBg" on:click={pop} transition:fade={{ duration: 125 }}>
        <div class="cancel">
          <textarea
            name="reason"
            cols="30"
            rows="10"
            placeholder="סיבה"
            bind:value={cancelReason}
            on:click={(e) => {
              e.stopPropagation();
            }}
          />
          <div
            class="cancelBtn"
            on:click={async () => {
              try {
                $loading = true;
                await OrderDAL.cancelAndRefund(orderToCancel.id, cancelReason);
                $loading = false;
              } catch (e) {
                $loading = false;
                showPopup('...משהו השתבש', () => {});
                UserDAL.sendLog('cancel and refund', e.toString());
              }
            }}
          >
            בטל הזמנה
          </div>
        </div>
      </div>
    {/if}
    <div class="container">
      <div
        class="cover"
        style={`background-image: url(${BusinessDAL.getCoverImgUrl($business.code)})`}
      >
        <div
          class="info"
          on:click={() => {
            push('/b/' + $business.code);
          }}
        >
          <h1 class="title">
            {$business.title}
            <div class="openCloseSign">
              {#if isOpen}
                <span class="open">פתוח</span>
              {:else}<span class="closed">סגור</span>{/if}
            </div>
          </h1>
          <h1 class="address">{$business.address}</h1>
          <h1 class="hours">
            {openToday ? formatHours(openFrom, openTo) : ''}
          </h1>
        </div>

        <div class="openClose" class:open={$business.open}>
          <div
            class="openBtn"
            on:click={() => {
              BusinessDAL.openBusiness(params.code);
            }}
          >
            פתוח
          </div>
          <div
            class="closeBtn"
            on:click={() => {
              BusinessDAL.closeBusiness(params.code);
            }}
          >
            סגור
          </div>
        </div>
      </div>

      <div class="configs">
        <div class="config">
          <input
            id="notifications"
            type="checkbox"
            on:change={(e) => {
              if (e.target.checked) startAudioLoop();
              NotificationsBL.setNotifications(e.target.checked, $business.code, $fcmToken);
            }}
            bind:checked={getNotifications}
          />
          <label for="notifications">קבל נוטיפיקציה כשנכנסת הזמנה</label>
        </div>
        <div class="configButtons">
          <div
            class="editMenu"
            on:click={() => {
              push($location + '/EditMenu');
            }}
          >
            <span>
              <EditIcon color="#7ed0ff" width="24px" />
            </span>
            עריכת תפריט
          </div>
          <div
            class="editMenu"
            on:click={() => {
              push($location + '/EditLoyalty');
            }}
          >
            <span>
              <EditIcon color="#7ed0ff" width="24px" />
            </span>
            עריכת כרטיסיות
          </div>
          <div
            class="editMenu"
            on:click={() => {
              push(`${$location}?editStock=true`);
            }}
          >
            <span>
              <EditIcon color="#7ed0ff" width="24px" />
            </span>
            ניהול חוסרים
          </div>
          <div
            class="editMenu"
            on:click={() => {
              push(`${$location}?editHours=true`);
            }}
          >
            <span>
              <FaClock />
            </span>
            שעות פתיחה
          </div>
          <div
            class="editMenu"
            on:click={() => {
              push(`${$location}?editDeliveries=true`);
            }}
          >
            <span>
              <VespaIcon color="#7ed0ff" />
            </span>
            הגדרות משלוחים
          </div>
          <div
            class="editMenu"
            on:click={() => {
              push($location + '/Graphs');
            }}
          >
            <span>
              <FaChartBar />
            </span>
            גרפים
          </div>
          <div
            class="editMenu"
            on:click={() => {
              $toastMsg = 'לינק הועתק';
              copyToClipboard(`https://cognituspickapp.page.link/${$business.code}`);
            }}
          >
            <span>
              <FaCopy />
            </span>
            לינק לשיתוף
            <input
              class="shareLinkInput"
              type="text"
              value="https://cognituspickapp.page.link/{$business.code}"
            />
          </div>
        </div>
        {#if $openOrders.length > 0}
          <div class="filters">
            <h2>סינון</h2>
            {#each menuItemCategories as category}
              <input
                type="checkbox"
                id={category}
                value={category}
                bind:group={$categoryFilters}
                on:change={() => {
                  $orders = $orders;
                }}
              />
              <label for={category}>{category}</label><br />
            {/each}
          </div>
        {/if}
      </div>

      <div class="orders">
        {#if $ordersFilteredByCategory}
          {#each $ordersFilteredByCategory as order, i (order.id)}
            <div class="item" animate:flip transition:fade={{ duration: 125 }}>
              <AdminOrder
                {order}
                on:cancelOrder={(o) => {
                  orderToCancel = o.detail;
                  push($location + '?showCancel=true');
                }}
              />
            </div>
          {/each}
        {/if}
      </div>
      {#if $closedOrders && $closedOrders.length > 0}
        <h2>הזמנות אחרונות</h2>
        <div class="closedOrders">
          {#each $closedOrders as order, idx (order.id)}
            <ClosedOrderItem {order} {idx} />
          {/each}
        </div>
      {/if}
    </div>
  {/if}
</main>

<style>
  .shareLinkInput {
    outline: none;
    border: none;
    width: 70%;
    direction: ltr;
    border-radius: 4px;
    font-size: 15px !important;
    margin-left: 0 !important;
    margin-right: auto !important;
    margin-bottom: 0 !important;
  }
  .openCloseSign > .open {
    color: var(--green1);
    border: 3px solid;
    padding: 1px 10px 3px 10px;
    border-radius: 100px;
    font-size: 24px;
  }
  .openCloseSign {
    display: inline-flex;
  }

  .openCloseSign > .closed {
    color: var(--red1);
    border: 3px solid;
    padding: 1px 10px 3px 10px;
    border-radius: 100px;
    font-size: 24px;
  }
  .filters {
    display: flex;
    gap: 5px;
    align-items: baseline;
  }
  .config > span > img {
    width: 100%;
    height: 100%;
  }

  main {
    width: 100%;
    display: flex;
    justify-content: center;
    min-height: calc(100vh - var(--nav-bar-height));
    overflow-x: hidden;
  }

  .container {
    width: 100%;
    max-width: 560px;
    margin-bottom: 30px;
    height: fit-content;
    margin-top: 30px;
    direction: rtl;
  }

  .cover {
    width: 100%;
    height: 300px;
    direction: inherit;
    background-size: cover;
    background-position: center;
    display: flex;
    overflow: hidden;
    box-shadow: 0px 10px 12px -13px #00000078;
    border-radius: 5px 5px 25px 25px;
    overflow: hidden;
    flex-direction: column;
    justify-content: flex-end;
    margin-bottom: 30px;
    border-radius: 12px;
  }

  h1 {
    margin: 0;
    padding: 0;
  }

  h2 {
    font-size: 15px;
    margin: 10px 10px;
  }

  .info {
    width: 100%;
    background: #000000a8;
    color: white;
    font-family: "Rubik";
    font-size: 1.5rem;
    padding: 15px;
    user-select: none;
    cursor: pointer;
  }

  .title {
    font-size: 3rem;
  }

  .hours,
  .address {
    font-size: 2rem;
    font-weight: 500;
  }

  .address {
    margin-top: 5px;
  }

  .openClose {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    cursor: pointer;
  }

  .openClose > div {
    width: 50%;
    height: 60px;
    font-family: "Rubik";
    font-size: 24px;
    font-weight: 100;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .openBtn {
    color: var(--green1);
    background: white;
  }

  .closeBtn {
    background: var(--red1);
    color: white;
  }

  .open > .openBtn {
    background: var(--green1);
    color: white;
  }

  .open > .closeBtn {
    background: white;
    color: var(--red1);
  }

  @media only screen and (max-width: 560px) {
    .container {
      margin-top: 0;
    }

    .cover {
      border-radius: 0;
    }
  }

  .cancelBg {
    position: fixed;
    width: 100%;
    height: 100%;
    background: #0008;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 999;
  }

  .cancel {
    width: 100%;
    max-width: 390px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    direction: rtl;
    background: white;
    padding: 10px;
    border-radius: 4px;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    position: relative;
    box-sizing: border-box;
    font-family: "Rubik";
    align-items: center;
    margin-bottom: 200px;
  }

  .cancel > textarea {
    width: 100%;
    border-radius: 3px;
    resize: none;
    color: #585858;
    font-family: "Rubik";
    font-size: 17px;
    outline: none;
    height: 100px;
    padding: 10px 20px;
  }

  .cancelBtn {
    width: 50%;
    border: none;
    color: #fff;
    outline: none;
    border-radius: 3px;
    margin: 2px;
    background-color: var(--red1);
    padding: 13px;
    text-align: center;
    /* box-shadow: 0px 0px 0px 5px #e94e4e, 0px 10px 0px 5px #cf4343; */
    margin: 20px;
    cursor: pointer;
    user-select: none;
  }

  .configs {
    box-shadow: 0px 10px 33px -30px black;
    padding: 10px;
    margin-bottom: 20px;
    background: #fff;
    border-radius: 3px;
    font-size: 17px;
  }

  .configButtons {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin: 20px 6px;
  }

  .config {
    display: flex;
    align-items: center;
  }

  .config > input,
  label {
    display: inline-block;
    margin: 0;
    margin-left: 5px;
    font-size: 17px;
  }

  .closedOrders {
    border-radius: 10px;
    background: #ffffff;
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    table-layout: fixed;
    box-shadow: 0px 5px 20px -12px black;
  }

  .editMenu {
    padding: 12px;
    display: inline-flex;
    border-radius: 10px;
    background: #f3f3f3;
    color: #707070;
    user-select: none;
    cursor: pointer;
    flex: 1;
    min-width: fit-content;
    font-size: 1.5rem;
    align-items: center;
  }

  .editMenu > img,
  .editMenu > span {
    width: 25px;
    height: 25px;
    display: inline-block;
    margin-left: 15px;
    color: #7ed0ff;
  }

</style>
